let footerMenuCleanup = null;

function handleAccordionClick(accordion) {
  const column = accordion.closest('.accordion-column');
  const panel = column?.querySelector('.accordion-panel');
  const plusIcon = accordion.querySelector('.plus-icon-span');
  const minusIcon = accordion.querySelector('.minus-icon-span');

  if (!panel || !plusIcon || !minusIcon) {
    console.error('Missing required elements for accordion');
    return;
  }

  accordion.classList.toggle('active');

  const isOpen = panel.classList.toggle('show');
  panel.classList.toggle('hide', !isOpen);
  plusIcon.classList.toggle('hide', isOpen);
  minusIcon.classList.toggle('hide', !isOpen);
}

function resetFooterMenuState(footer) {
  const accordions = footer.querySelectorAll('.footer-accordion');

  accordions.forEach((accordion) => {
    const column = accordion.closest('.accordion-column');
    const panel = column?.querySelector('.accordion-panel');
    const plusIcon = accordion.querySelector('.plus-icon-span');
    const minusIcon = accordion.querySelector('.minus-icon-span');

    accordion.classList.remove('active');

    if (panel) {
      panel.classList.remove('show');
      panel.classList.add('hide');
    }

    if (plusIcon) {
      plusIcon.classList.remove('hide');
    }

    if (minusIcon) {
      minusIcon.classList.add('hide');
    }
  });
}

function initFooterMenu() {
  const footer = document.querySelector('.footer__item-list');

  if (!footer) {
    return null;
  }

  const onClick = (e) => {
    const accordion = e.target.closest('.footer-accordion');

    if (!accordion || !footer.contains(accordion)) {
      return;
    }

    handleAccordionClick(accordion);
  };

  footer.addEventListener('click', onClick);

  return () => {
    footer.removeEventListener('click', onClick);
    resetFooterMenuState(footer);
  };
}

const windowSize = window.matchMedia('(max-width: 999px)');

function handleFooterMenuByScreen(event) {
  const isMobile = event?.matches ?? windowSize.matches;

  if (isMobile) {
    if (!footerMenuCleanup) {
      footerMenuCleanup = initFooterMenu();
    }
    return;
  }

  if (footerMenuCleanup) {
    footerMenuCleanup();
    footerMenuCleanup = null;
  }
}

windowSize.addEventListener('change', handleFooterMenuByScreen);
handleFooterMenuByScreen();
